import { ApolloError } from '@apollo/client';
import React, { useMemo, useState } from 'react';
import EDDialog from '../Dialog/EDDialog';
import EDTypography from '../Typography/EDTypography';

interface IProps {}

interface IErrorDialogContext {
  error: (message: string, apolloError?: ApolloError) => void;
}

export const ErrorDialogContext = React.createContext<IErrorDialogContext>({
  error: () => {},
});

const ErrorDialogManager: React.FC<React.PropsWithChildren<IProps>> = props => {
  const [open, setOpen] = useState(false);
  const [moreInfoDialogOpen, setMoreInfoDialogOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [apolloError, setApolloError] = useState<ApolloError | null>(null);

  const value = useMemo(
    () => ({
      error: (message: string, apolloError?: ApolloError) => {
        setOpen(true);
        setMessage(message);
        if (apolloError) {
          setApolloError(apolloError);
        }
      },
    }),
    [setOpen]
  );

  return (
    <>
      <ErrorDialogContext.Provider value={value}>
        {props.children}
      </ErrorDialogContext.Provider>
      <EDDialog
        open={open}
        title={'Fel'}
        onClose={() => setOpen(false)}
        footerActions={[
          ...(apolloError
            ? [
                {
                  label: 'Öppna teknisk information',
                  onClick: () => setMoreInfoDialogOpen(true),
                },
              ]
            : []),
          {
            label: 'Stäng',
            onClick: () => setOpen(false),
          },
        ]}
        onExited={() => {
          setMessage('');
          setApolloError(null);
        }}
        isErrorDialog
      >
        <EDTypography variant="body2">{message}</EDTypography>
      </EDDialog>
      {apolloError && (
        <EDDialog
          open={moreInfoDialogOpen}
          title={'Teknisk information'}
          onClose={() => setMoreInfoDialogOpen(false)}
          footerActions={[
            {
              label: 'Stäng',
              onClick: () => setMoreInfoDialogOpen(false),
            },
          ]}
          isErrorDialog
        >
          <EDTypography variant="body2">{apolloError.message}</EDTypography>
        </EDDialog>
      )}
    </>
  );
};

export default ErrorDialogManager;
